import { Copy } from 'phosphor-react';

import NeedTimeFileContractorReport from 'components/need-time-file-contractor-report';
import CopyToClipboardButton from 'components/copy-icon';
import { ReportFilingDataInterface } from 'types/report';

function FileContractorReport({
  contractorFilingData
}: {
  contractorFilingData: ReportFilingDataInterface | null;
}): JSX.Element {
  return (
    <>
      <NeedTimeFileContractorReport />
      <div className="text-xl font-medium leading-6 text-gray-900 mt-10 pb-4">Ready to file?</div>
      <div className="pl-5 border-l-4 border-gray-200">
        <ul className="text-gray-900 text-base font-normal leading-8 mb-4 list-decimal ml-5">
          <li>
            Log into the&nbsp;
            <a
              href="https://pdr.calcivilrights.ca.gov/s/"
              className="btn-link"
              target="_blank"
              rel="noreferrer">
              CA Pay Data Reporting Portal
            </a>
            &nbsp;(or click &quot;Home&quot; if you are already on the portal)
          </li>
          <li>Start a submission (for the current reporting year, if filing for 2022) </li>
          <li>Select an employer, or create and select a new employer </li>
          <li>Select Create Labor Contractor Report </li>
          <li className="leading-7">
            Confirm employer info <br />
            <span className="font-semibold">Hint:</span> You can easily copy and paste each field by
            clicking the&nbsp;
            <Copy size="1.1rem" weight="bold" className="inline text-gray-800" />
            <div className="w-fit grid grid-cols-2 gap-6 mt-6 mb-4">
              <div>
                <label className="block text-sm font-semibold text-gray-900 mb-2">
                  Total Number of U.S. Establishments with Labor Contractor Employees
                </label>
                <div className="input h-12 w-64 mb-0 relative" data-testid="us-establishments">
                  {contractorFilingData?.USEstablishments}
                  <CopyToClipboardButton
                    text={contractorFilingData?.USEstablishments?.toString() ?? ''}
                  />
                </div>
              </div>
              <div>
                <label className="block text-sm font-semibold text-gray-900 mb-2">
                  Total U.S. labor contractor employees
                </label>
                <div className="input h-12 w-64 mb-0 relative" data-testid="us-employees">
                  {contractorFilingData?.USEmployees}
                  <CopyToClipboardButton
                    text={contractorFilingData?.USEmployees?.toString() ?? ''}
                  />
                </div>
              </div>
              <div>
                <label className="block text-sm font-semibold text-gray-900 mb-2">
                  Total Number of CA Establishments with Labor Contractor Employees
                </label>
                <div className="input h-12 w-64 mb-0 relative" data-testid="ca-establishments">
                  {contractorFilingData?.CAEstablishments}
                  <CopyToClipboardButton
                    text={contractorFilingData?.CAEstablishments?.toString() ?? ''}
                  />
                </div>
              </div>
              <div>
                <label className="block text-sm font-semibold text-gray-900 mb-2">
                  Total CA labor contractor employees
                </label>
                <div className="input h-12 w-64 mb-0 relative" data-testid="ca-employees">
                  {contractorFilingData?.CAEmployees}
                  <CopyToClipboardButton
                    text={contractorFilingData?.CAEmployees?.toString() ?? ''}
                  />
                </div>
              </div>
            </div>
          </li>
          <li>Click &quot;Import Data&quot; </li>
          <li>
            Certify and submit <br />
          </li>
        </ul>
        <div className="font-semibold">You&apos;re all done!</div>
      </div>
    </>
  );
}

export default FileContractorReport;
